import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ShoppingCart, X } from 'lucide-react';

export interface OfferSelectionBarProps {
  count: number;
  onClear: () => void;
  onSendProposal: () => void;
}

export const OfferSelectionBar: FC<OfferSelectionBarProps> = ({
  count,
  onClear,
  onSendProposal,
}) => {
  const { t } = useTranslation();

  if (count === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-20 left-1/2 z-40 -translate-x-1/2 md:bottom-6">
      <div className="flex items-center gap-4 rounded-2xl bg-gradient-to-r from-indigo-500 to-violet-600 px-5 py-3 text-white shadow-2xl">
        <ShoppingCart className="h-4 w-4" />
        <span className="text-sm font-medium">
          {t('pages.admin.offers.bulk.selected', { count })}
        </span>
        <button
          className="cursor-pointer text-sm font-semibold whitespace-nowrap"
          type="button"
          onClick={onSendProposal}>
          {t('pages.admin.offers.sendProposal')} →
        </button>
        <button
          aria-label={t('buttons.cancel')}
          className="cursor-pointer rounded-lg p-1 hover:bg-white/15"
          type="button"
          onClick={onClear}>
          <X className="h-4 w-4" />
        </button>
      </div>
    </div>
  );
};

OfferSelectionBar.displayName = 'OfferSelectionBar';
